import React from "react";
import ImageGrid from "../../../components/company_grid";
import Footer from "../../../components/footer";
import CompanyHeroSection from "./our_company_page";
import HistorySection from "./history_section";
import PeriodSection from "./period_section";
import DesginSection from "./design"

function Our_Company() {
  return (
    <div>
      <CompanyHeroSection />
      <HistorySection/>
      <PeriodSection/>
      <DesginSection/>
      <ImageGrid />
      <Footer />
    </div>
  );
}

export default Our_Company;
